import { mapGetters } from "vuex";
import { getParameter, exitFullscreen } from "@/utils/global";
import Bus from "@/components/doc/bus";
export const meetInfo = {
  name: "meetInfo",
  props: {},
  data() {
    return {
      meetInfo: null,
      joinList: [], //管理列表:对应云视参会人已入会列表
      joiners: new Map(),
      streamType: "",
      roomId: "",
      joinName: "",
      hostCode: "",
      user: "",
      successReconnect: false
    };
  },
  computed: {
    ...mapGetters(["rtcClient", "userInfo", "micDefault", "selfParticipant"]),
  },
  methods: {
    // 进入云视会议
    joinRoom(roomId, joinName, hostCode, user) {
      this.roomId = roomId;
      this.joinName = joinName;
      this.hostCode = hostCode;
      this.user = user;
      let serverUrl = {
        meetUrl: config.meetUrl,
        ccUrl: config.ccUrl,
      };
      this.rtcClient.SetServer(serverUrl);
      return new Promise((resolve, reject) => {
        console.log(this.rtcClient);
        const appid = getParameter("loginStyle") == "v2" ? "cloud_webcast" : null;
        this.rtcClient
          .JoinRoom(roomId, joinName, hostCode, true, appid, user)
          .then((res) => {

            if (res && !res.loginCCRes) {
              this.$router.push({
                name: "Err",
                query: {
                  m: this.$t("meet.直播间不存在"),
                },
              });
              return;
            }
            this.meetInfo = res;
            // debugger
            console.log(this.meetInfo, "meetInfo");
            console.log(this.rtcClient, "rtcClient");
            this.$store.commit("SET_JION_ROOM", true)
            this.addEvent();
            this.$store.commit("SET_SID", this.rtcClient.RTMSession.sid);
            this.$store.commit(
              "SET_USERINFO",
              Object.assign(this.rtcClient.RTMSession.userInfo, {
                name: joinName,
              }),
            );
            this.$store.commit("SET_MEETSTATUS_INFO", res);

            this.joinList = JSON.parse(JSON.stringify(this.rtcClient.RTCRoom.getJoinedList()));
            //TODO
            this.$store.commit("SET_JOINEDLIST", this.rtcClient.RTCRoom.getJoinedList());
            console.log(this.rtcClient.RTCRoom.getJoinedList(), "参会人刚进入时");
            const selfParticipant = this.rtcClient.RTCRoom.getJoinedList().find((info) => {
              return info.uid == this.userInfo.uid;
            });
            if (selfParticipant) {
              this.$store.commit("SET_SELFPARTICIPANT", selfParticipant);
            }
            console.log(selfParticipant, "selfParticipant");
            // this.rtcClient.RTCRoom.publishLocalStream({
            //   VideoInputDeviceId: true,
            //   AudioInputDeviceId: true,
            // })
            //   .then((res) => {
            //     resolve(res.streamsrc);
            //   })
            //   .catch((err) => {
            //     reject(err);
            //   });
            console.log(this.rtcClient.RTCRoom.shareStream, "shareStream");
            if (this.rtcClient.RTCRoom.shareStream) {
              this.$store.commit("SET_ISCHANGEAREA", true);
            }

            if(this.successReconnect){
              Bus.$emit("onRePub")
              Bus.$emit("onReSub")
            }
            this.logger.info({
              code: 2004,
              message: res,
            });
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 音频主控/自由模式切换
    async changeControlStatus(status, type) {
      this.rtcClient.RTCRoom.setRoomAuth({ type, value: status });
    },
    async changeAudioStatus(status) {
      await this.rtcClient.RTCRoom.MuteRoomAudio(status);
      await this.rtcClient.RTCRoom.MuteRoomVideo(status);
    },

    addEvent() {
      this.rtcClient.RTCRoom.addEventListener("participantChange", (res) => {
        // 参会人发生改变
        console.log(res, "participantChange");
        const curJoined = this.joinList.find((info) => {
          return info && res.data && res.data.uid && info.uid == res.data.uid;
        });
        this.logger.info({ code: 2005, message: res });
        if (res.event == "modity") {
          if (!curJoined) {
            if (res.data.type) {
              // let role = res.data.type == 3 ? '主播' : res.data.type == 2 ? "助手" : "嘉宾"
              // this.$message.success(`【${role}${res.data.name}】进来了`);
              // Bus.$emit('systemMsg', `【${role}${res.data.name}】进来了`);
            } else {
              this.joiners.set(`${res.data.uid}_${res.data.cid}`, {
                uid: res.data.uid,
                cid: res.data.cid,
              });
            }
          } else {
            if (this.joiners.has(`${res.data.uid}_${res.data.cid}`)) {
              // let role = res.data.type == 3 ? '主播' : res.data.type == 2 ? "助手" : "嘉宾"
              // this.$message.success(`【${role}${res.data.name}】进来了`);
              // Bus.$emit('systemMsg', `【${role}${res.data.name}】进来了`);
              this.joiners.delete(`${res.data.uid}_${res.data.cid}`);
            }
          }
        } else if (res.event == "del" && curJoined) {
          // let role = curJoined.type == 3 ? '主播' : curJoined.type == 2 ? "助手" : "嘉宾"
          // this.$message.success(`【${role}${curJoined.name}】离开了`);
          // Bus.$emit('systemMsg', `【${role}${curJoined.name}】离开了`)
        }
        console.log(this.joinList, "this.joinList");
        // debugger;
        let joinedList = this.rtcClient.RTCRoom.getJoinedList();
        //TODO 此处不可以这样处理，需找其它方法，protal 重连后主播变嘉宾问题
        // const targetJoined = joinedList.find(item => item.role === 'host' && item.avctl === 1);
        // if(targetJoined){
        //   targetJoined.type = 3;
        // }
        // joinedList.forEach(item=>{
        //   if(item.type == 3){
        //     item.role = "host"
        //   }
        //   if(item.role === "host"){
        //     item.type = 3
        //   }
        // })
        Bus.$emit("participantChange");
        console.log(joinedList, "joinedList 改变 。。。。")
        this.joinList = JSON.parse(JSON.stringify(joinedList));
        //TODO
        this.$store.commit("SET_JOINEDLIST", joinedList);
        const selfParticipant = joinedList.find((info) => {
          return info.uid == this.userInfo.uid;
        });
        if (selfParticipant) {
          this.$store.commit(
            "SET_USERINFO",
            Object.assign(this.userInfo, {
              name: selfParticipant.name,
            }),
          );
          console.log(selfParticipant, "自己");
          this.$store.commit("SET_SELFPARTICIPANT", selfParticipant);
        }
        console.log(joinedList, "joinedList 改变 。。。。");
      });
      this.rtcClient.RTCRoom.addEventListener("roomStatusChange", (res) => {
        console.log(res);
        this.logger.info({ code: 2006, message: res });
        if (res.event === "onAudiostatuschange") {
          this.meetInfo.audio = res.data.audio;
          this.$store.commit("SET_MEETSTATUS_INFO", this.meetInfo);
        } else if (res.event === "onLayoutChange") {
          this.$store.commit("SET_LAYOUTDATA", res.data);
        } else if (res.event === "onStreamShareadded") {
          const type = res.data.type;
          if (type === "webrtc") {
            this.$store.commit("SET_SHARE_TYPE", 2);
          } else if (type === "streaming") {
            this.$store.commit("SET_SHARE_TYPE", 3);
          }
          this.oldErea = this.$store.getters.isChangeArea;
          console.log(this.oldErea, "oldErea");
          this.streamType = res.data.type;
          //有流强制切换放大，2.1加
          this.$store.commit("SET_ISCHANGEAREA", true);
          Bus.$emit("ischangearea",true);
          console.log("onStreamShareadded::", res);
          if (!res.data.userInfo || res.data.userInfo.uid != this.userInfo.uid) {
            console.log("结束共享。。。")
            Bus.$emit("closeShare");
            Bus.$emit("closeShareBtn");
          }
        } else if (res.event == "onAuthChange") {
          let meetInfo = JSON.parse(JSON.stringify(this.meetInfo));
          meetInfo.groupInfo[`${res.data.type}`] = res.data.value;
          this.meetInfo = meetInfo;
          this.$store.commit("SET_MEETSTATUS_INFO", this.meetInfo);
          this.$nextTick(() => {
            Bus.$emit("authChange");
          });
        } else if (res.event == "onRoomStatusChange") {
          // meetStatus   'leave' or 'end'
          Bus.$emit("liveStatusChange", res.data);
        } else if (res.event == "onHostChange") {
        // setTimeout(() => {
          console.log('修改为主播。。。。');

          const hostUid = res.data.owner.uid;
          let joinedList = this.rtcClient.RTCRoom.getJoinedList();
          let oldHost = joinedList.find((info) => {
            return info.type == 3;
          });
          if (oldHost) {
            oldHost.type = 1;
          }
          let newHost = joinedList.find((info) => {
            return info.uid == hostUid;
          });
          if (newHost) {
            newHost.type = 3;
          }
          //TODO
          this.$store.commit("SET_JOINEDLIST", joinedList);
          if (this.$store.getters.selfParticipant) {
            let selfParticipant = this.$store.getters.selfParticipant;
            if (res.data.owner.uid == this.$store.getters.selfParticipant.uid) {
              selfParticipant.type = 3;
            } else {
              selfParticipant.type = 1;
            }
            this.$store.commit("SET_SELFPARTICIPANT", selfParticipant);
          }

          // 不是自己操作
          // if (this.userInfo.uid !== res.data.handler.uid) {
          //   if (this.userInfo.uid === res.data.owner.uid) {
          //     this.$alert(this.$t('App.您升级为主播'), {
          //       title: this.$t('App.提示'),
          //       customClass: "tip-alert",
          //       confirmButtonText: this.$t('App.我知道了'),
          //     });
          //   }
          // }
          if (res.data.extra) {
            // "{"type":"snatch_host"}"
            const extra = JSON.parse(res.data.extra);
            if (extra) {
              // 其他用户抢夺主播角色
              if (extra.type === "snatch_host") {
                if (this.userInfo.uid === res.data.handler.uid) {
                  this.$alert(this.$t("controller.主播角色已成功转移至") + "【" + res.data.owner.name + "】", {
                    title: this.$t("App.提示"),
                    customClass: "tip-alert",
                    confirmButtonText: this.$t("App.我知道了"),
                  });
                }
              }
              if (extra.type === "give_up_host") {
                if (this.userInfo.uid === res.data.owner.uid) {
                  this.$alert(this.$t("App.您升级为主播"), {
                    title: this.$t("App.提示"),
                    customClass: "tip-alert",
                    confirmButtonText: this.$t("App.我知道了"),
                  });
                }
              }
            }
          }
        // },500)

          console.log(res.data, "===========================");
        } else if (res.event == "onRelogin") {
          //重连后先清空，再获取 portal重连
          let joins = [];
          joins = this.rtcClient.RTCRoom.getJoinedList();
          //断线重连后type可能由3变为1，可以根据role判断,修改为3
          joins.forEach(element => {
            if(element.role == 'host'){
              element.type = 3
            }
          });
          this.joinList = JSON.parse(JSON.stringify(joins));
          //TODO onRelogin
          // debugger
          console.log(joins, "参会的人重新连接");
          this.$store.commit("SET_JOINEDLIST", joins);
          const selfParticipant = joins.find((info) => {
            return info.uid == this.userInfo.uid;
          });
          if (selfParticipant) {
            this.$store.commit("SET_SELFPARTICIPANT", selfParticipant);
          }
          this.logger.info({ code: 2038, message: res });
          Bus.$emit("onRelogin");
          console.log(selfParticipant, "onRelogin selfParticipant");
        } else if (res.event == "onSocketStatusChange") {
          console.log("onSocketStatusChange....", res);
          if (res.data == "Connected") {
            Bus.$emit("ConnectedCC");
            Bus.$emit("tips", {
              content: this.$t("meet.已连接到直播流服务"),
              time: 2,
            });
            this.logger.info({ code: 2067, message: {msg: 'cc连接成功'}});
          } else if (res.data == "ReConnected") {
            //  重连中
            Bus.$emit("tips", {
              content: this.$t("meet.检测到与直播流服务的连接断开"),
              time: 1,
            });
          } else if (res.data == "DisConnected") {
            //cc重连失败
            Bus.$emit("exitRoom", this.$t("meet.无法与直播流服务器取得连接"));
            this.logger.info({ code: 2068, message: {msg: 'cc重连失败'}});
          }
          this.logger.info({ code: 2039, message: res });
        } else if (res.event == "onOwtStatusChange") {
          if(res.data.type === 'serverdisconnected') {
            console.log('protal断开')

          }
          // console.log(res.data, "onOwtStatusChange...")
          if(res.data.type === 'more_reconnect_failed'){
            console.log('未连上退出')
            // // owt重连失败
            Bus.$emit('exitRoom', '无法与直播服务器取得连接，请重新登录');
            this.logger.info({ code: 2069, message: {msg: 'owt未连上退出'}});
          }
          if(res.data.type == "owt_reconnect_success") {
            console.log('已经连上')
            this.successReconnect = true;
            this.logger.info({ code: 2070, message: {msg: 'owt已经连上'}});
          }
        } else if (res.event == "onPublicLocalended") {
          Bus.$emit("onPublicLocalended");
        } else if (res.event == "onStreamended") {
          console.log(sessionStorage.getItem("oldErea"), "收到结束流oldErea");
          let isFull = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
          console.log(isFull, " 是否有全屏 ");

          //无流强制切换至原来位置，2.1加,如果同一种流那么恢复之前的设置
          if (this.streamType === res.data.type) {
            console.log("是同种流");
            if ((res.data.source.video && res.data.source.video === "screen-cast") || res.data.type === "streaming") {
              this.$store.commit("SET_ISCHANGEAREA", sessionStorage.getItem("oldErea") === "true" ? true : false);

              Bus.$emit("ischangearea",sessionStorage.getItem("oldErea") === "true" ? true : false);
              if (isFull) {
                exitFullscreen();
              }
            }
          }
          if (res.data.type === "streaming") {
            this.$store.commit("SET_MEDIASTATUS", -1);
          }
          this.$store.commit("SET_SHARE_TYPE", -1);
          if(res.data.source.video === 'screen-cast'){
            Bus.$emit("closeShareLayout");
          }
        } else if (res.event == "onMediaStatusChange") {
          if (`${this.userInfo.cid}.${this.userInfo.uid}` == res.data.origin) return;
          if (this.selfParticipant.streamId != res.data.id) return;
          if (res.data.data.field == "video.status") {
            res.data.data.value == "active" ? this.$message.success(this.$t("meet.您的摄像头已打开")) : this.$message.success(this.$t("meet.您的摄像头已关闭"));
          }
          if (res.data.data.field == "audio.status") {
            res.data.data.value == "active" ? this.$message.success(this.$t("meet.您的麦克风已打开")) : this.$message.success(this.$t("meet.您的麦克风已关闭"));
          }
        }
      });
    },
  },
};
